import { HEADERS, STORAGE_KEYS } from "@/modules/home/constant";
import axios from "axios";
import { toast } from "@/utils/useToast";

// Create Axios instance
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  timeout: 30000,
  headers: HEADERS
});


apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_KEYS.LOCAL_STORAGE);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor - Global Error Handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.message || "An error occurred";
    if (error.response) {
      console.error("API Error:", message);
    }
    // Prevent duplicate toasts if handled locally, but for now global is safer
    // We can check a config flag if we want to suppress global toast
    if (!error.config?.suppressToast) {
      toast.error(message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
